import React from 'react'
import { Navigate, useLocation } from 'react-router-dom'

function CommonCheckAuth({ isAuthenticated, user, children }) {
    const location = useLocation();

    if (!isAuthenticated && location.pathname !== '/login' && location.pathname !== '/register') {
        return <Navigate to="/login" state={{ from: location }} replace />;
    }

    // Si l'utilisateur n'est pas authentifié
    if (!isAuthenticated) {
        if (location.pathname !== '/login' && location.pathname !== '/register') {
            return <Navigate to="/login" state={{ from: location }} replace />;
        }
    }

    // Si authentifié et sur une page publique
    if (isAuthenticated &&
        (location.pathname === '/login' || location.pathname === '/register' ||
            location.pathname === '/reset-password' || location.pathname === '/forgot-password')) {
        const from = location.state?.from?.pathname || '/';
        return <Navigate to={from} replace />;
    }


    return children;

}

export default CommonCheckAuth